/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_P2_TitleInputs */

const es_cap_p2_title = /** @type {(inputs: Cap_P2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trabaja por libre`)
};

const gl_cap_p2_title = /** @type {(inputs: Cap_P2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traballa por libre`)
};

const en_cap_p2_title = /** @type {(inputs: Cap_P2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Work on your terms`)
};

/**
* | output |
* | --- |
* | "Work on your terms" |
*
* @param {Cap_P2_TitleInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const cap_p2_title = /** @type {((inputs?: Cap_P2_TitleInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_P2_TitleInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_cap_p2_title(inputs)
	if (locale === "en") return en_cap_p2_title(inputs)
	return es_cap_p2_title(inputs)
});